import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { api } from '../api/client';
import type { PostDetail as PostDetailType } from '../types/api';

const PostDetail: React.FC = () => {
  const { postId } = useParams<{ postId: string }>();
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [post, setPost] = useState<PostDetailType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!postId) return;
    api.posts.get(postId, token)
      .then(setPost)
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, [postId, token]);

  if (loading) return <div style={{ padding: '24px', color: '#9ca3af' }}>Loading…</div>;
  if (error) return <div style={{ padding: '24px', color: '#dc2626' }}>{error}</div>;
  if (!post) return null;

  return (
    <div style={{ padding: '24px', maxWidth: '700px', margin: '0 auto' }}>
      <Link to="/posts" style={{ color: '#4ade80', textDecoration: 'none', marginBottom: '16px', display: 'inline-block' }}>← Posts</Link>
      <span style={{ fontSize: '12px', color: '#4ade80', textTransform: 'uppercase' }}>{post.type}</span>
      <h1 style={{ color: '#fff', marginTop: '8px', marginBottom: '8px' }}>{post.title}</h1>
      <p style={{ color: '#9ca3af', fontSize: '14px' }}>{post.authorDisplayName || post.authorId}</p>
      <div style={{ color: '#d1d5db', marginTop: '24px', whiteSpace: 'pre-wrap' }}>{post.content}</div>
      {post.comments && post.comments.length > 0 && (
        <div style={{ marginTop: '32px', borderTop: '1px solid #374151', paddingTop: '16px' }}>
          <h2 style={{ color: '#fff', fontSize: '1rem', marginBottom: '12px' }}>Comments</h2>
          {post.comments.map((c) => (
            <div key={c.commentId} style={{ marginBottom: '12px', paddingLeft: '12px', borderLeft: '2px solid #374151' }}>
              <p style={{ color: '#9ca3af', fontSize: '14px' }}>{c.authorDisplayName || c.authorId}</p>
              <p style={{ color: '#d1d5db' }}>{c.content}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PostDetail;
